export default {
  data() {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    const winH = window.innerHeight;
    const tableHeight = winH - 266; // - 60 - 61 - 20 - 30 - 33 - 20 - 32
    return {
      defaultDate: date,
      date: [],
      list: [],
      listBodyHeight: tableHeight,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '上个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 1, 1);
              end.setDate(1);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      loading: false,
      page: {
        currentPage: 1,
        pageSize: 20,
        pageSizes: [20, 30, 50],
        total: 0
      }
    }
  },
  watch: {
    date() {
      this.page.currentPage = 1;
      this.getDataList();
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getDataList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.currentPage = 1;
      this.getDataList();
    }
  }
}